<template>
  <!-- Layout wrapper -->
  <div class="layout-wrapper layout-content-navbar">
    <div class="layout-container">
      <!-- Menu -->
      <MainMenu></MainMenu>
      <!-- / Menu -->

      <!-- Layout container -->
      <div class="layout-page">
        <!-- Content wrapper -->
        <div class="content-wrapper">
          <!-- Content -->

          <div class="container-xxl flex-grow-1 container-p-y">
            <div v-if="PageInfo.title"
                 class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
              <div class="d-flex flex-column justify-content-center">
                <h4 class="mb-1">{{ PageInfo.title }}</h4>
                <p class="mb-0" v-if="PageInfo.breadcrumbs.length">
                  <BreadCrumb></BreadCrumb>
                </p>
              </div>
              <slot name="top_buttons"></slot>
            </div>
            <slot></slot>
          </div>
          <!-- / Content -->

          <!-- Footer -->
          <BaseFooter></BaseFooter>
          <!-- / Footer -->


          <!-- Messages -->
          <MessagesComponent ref="BaseMessages"></MessagesComponent>
          <!-- / Messages -->

          <div class="content-backdrop fade"></div>
        </div>
        <!-- Content wrapper -->
      </div>
      <!-- / Layout page -->
    </div>

    <button
      type="button"
      class="mobile-menu-fab d-xl-none"
      :class="{ 'is-hidden': MobileMenu.open }"
      aria-label="Открыть меню"
      @click.stop.prevent="openMobileMenu"
    >
      <i class="ti ti-menu-2"></i>
    </button>

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle" :class="MobileMenu.open ? 'active' : ''"
         @click="MobileMenu.toggle()"></div>

    <!-- Drag Target Area To SlideIn Menu On Small Screens -->
    <div class="drag-target"></div>

    <!-- Модалка запроса телефона, если не указан -->
    <RequirePhoneModal
      v-if="showPhoneModal"
      :user-id="userId"
      @success="showPhoneModal = false"
      @close="showPhoneModal = false"
    />

    <!-- Виджет «посмотрите обзор» для пользователей без onboarded -->
    <OnboardingPrompt
      v-if="showOnboardingPrompt"
      :user-id="userId"
      @dismiss="showOnboardingPrompt = false"
    />
  </div>
  <!-- / Layout wrapper -->
</template>

<script>

import MainMenu from "@/components/page/Menu.vue";
import BaseFooter from "@/components/page/Footer.vue";
import {MobileMenu} from "@/data/menu";
import {PageInfo} from "@/data/page";
import BreadCrumb from "@/components/page/Breadcrumb.vue";
import MessagesComponent from "@/components/page/Messages.vue";
import RequirePhoneModal from "@/components/RequirePhoneModal.vue";
import OnboardingPrompt from "@/components/OnboardingPrompt.vue";
import {user} from "@/data/user";
import {getUser} from "@/api/user";
import {syncJivoCustomData} from "@/utils/jivo";

export default {
  name: 'BaseLayout',
  data() {
    return {
      showPhoneModal: false,
      showOnboardingPrompt: false,
    }
  },
  computed: {
    PageInfo() {
      return PageInfo
    },
    MobileMenu() {
      return MobileMenu
    },
    userId() {
      return user.user_id || localStorage.getItem('user_id') || ''
    }
  },
  methods: {
    openMobileMenu() {
      MobileMenu.open = true
    }
  },
  components: {OnboardingPrompt, RequirePhoneModal, MessagesComponent, BreadCrumb, BaseFooter, MainMenu},
  async mounted() {
    await user.getUserBase()
    if (!this.userId) return

    const companyId = await user.getActiveCompany()
    syncJivoCustomData({ userId: user.user_id, companyId })

    try {
      const res = await getUser(this.userId)
      const data = res?.data || {}
      const phone = data.phone
      if (phone === undefined || phone === null || String(phone).trim() === '') {
        this.showPhoneModal = true
      }
      if (data.onboarded !== true) {
        this.showOnboardingPrompt = true
      }
    } catch (_) {
      // не показываем модалку при ошибке загрузки (например, сеть)
    }
  },
}
</script>
<style scoped>
.layout-overlay.active {
  display: block;
}

.layout-overlay {
  transition: all 0.5s;
  z-index: 1080;
}

.mobile-menu-fab {
  position: fixed;
  top: 1rem;
  right: 1rem;
  bottom: auto;
  left: auto;
  z-index: 1030;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: #2f2b3d;
  box-shadow: 0 2px 8px rgba(47, 43, 61, 0.16);
  cursor: pointer;
}

.mobile-menu-fab .ti {
  font-size: 1.375rem;
  line-height: 1;
  pointer-events: none;
}

.mobile-menu-fab.is-hidden {
  opacity: 0;
  pointer-events: none;
}


@media (max-width: 1200px) {
  .layout-overlay {
    z-index: 1080;
  }
}
</style>

